import { render, staticRenderFns } from "./KeywordsRank.vue?vue&type=template&id=3e052920"
import script from "./KeywordsRank.vue?vue&type=script&lang=js"
export * from "./KeywordsRank.vue?vue&type=script&lang=js"
import style0 from "./KeywordsRank.vue?vue&type=style&index=0&id=3e052920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports